import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { InterceptorUtil, OCC_USER_ID_ANONYMOUS, OccEndpointsService, USE_CLIENT_TOKEN } from '@spartacus/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  EcConformityProductDocumentsPage,
  EcConformityProductDocumentsSearchParams,
  ProductBrand,
  ProductDocumentsWrapper,
} from '../../../core/model';
import { Occ } from '../../../core/occ';
import { ConverterService } from '../../../core/util/converter.service';
import { CONFORMANCE_EC_BRAND_NORMALIZER, CONFORMANCE_EC_SEARCH_NORMALIZER, PRODUCT_DOCUMENT_NORMALIZER } from './converters';

@Injectable({
  providedIn: 'root',
})
export class DocumentsConnector {
  constructor(
    private converterService: ConverterService,
    private httpClient: HttpClient,
    private occEndpointsService: OccEndpointsService
  ) {}

  // Product documents
  loadProductDocuments(userId: string, productCode: string, children: boolean = true): Observable<ProductDocumentsWrapper> {
    let headers = new HttpHeaders();
    if (userId === OCC_USER_ID_ANONYMOUS) {
      headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers);
    }

    const url = this.occEndpointsService.buildUrl('productDocuments', {
      urlParams: { userId: userId, productCode: productCode },
      queryParams: { children },
    });

    return this.httpClient
      .get<Occ.ProductDocumentsWrapper>(url, { headers })
      .pipe(this.converterService.pipeable(PRODUCT_DOCUMENT_NORMALIZER));
  }

  // Declaration Of Conformity
  conformanceEcSearch(searchParams: EcConformityProductDocumentsSearchParams): Observable<EcConformityProductDocumentsPage> {
    const headers = new HttpHeaders();
    const url = this.occEndpointsService.buildUrl('conformanceEcSearch', {
      queryParams: {
        brands: searchParams.brands,
        count: searchParams.count,
        page: searchParams.page,
        q: searchParams.q,
        sort: searchParams.sort,
      },
    });

    return this.httpClient
      .get<Occ.EcConformityProductDocumentsPage>(url, { headers })
      .pipe(this.converterService.pipeable(CONFORMANCE_EC_SEARCH_NORMALIZER));
  }

  loadConformanceEcBrands(): Observable<ProductBrand[]> {
    const headers = new HttpHeaders();
    const url = this.occEndpointsService.buildUrl('conformanceEcBrands', {});

    return this.httpClient.get<Occ.ProductBrandsWrapper>(url, { headers }).pipe(
      map((response) => response.brands),
      this.converterService.pipeableMany(CONFORMANCE_EC_BRAND_NORMALIZER)
    );
  }
}
